import { ApplicationConfig, provideZoneChangeDetection, importProvidersFrom } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideQueryClient, QueryClient } from '@ngneat/query';
import { withCredentialsInterceptor } from './core/interceptors/with-credentials.interceptor';
import { errorInterceptor } from './core/interceptors/error.interceptor';

import { routes } from './app.routes';
import { LucideAngularModule, CircleCheck, CircleAlert, X, ChevronDown, Search, Bell, History, RotateCcw, Monitor, Smartphone, Sun, Moon } from 'lucide-angular';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideHttpClient(withInterceptors([withCredentialsInterceptor, errorInterceptor])),
    provideAnimations(),
    provideQueryClient(() => new QueryClient()),
    importProvidersFrom(LucideAngularModule.pick({ CircleCheck, CircleAlert, X, ChevronDown, Search, Bell, History, RotateCcw, Monitor, Smartphone, Sun, Moon }))
  ]
};
